module.exports = __webpack_public_path__ + "static/media/gw.9e32ba13.svg";